<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_9_3471)">
<path d="M1 21.5651C3.26069 27.6578 9.12537 31.9999 16.0048 31.9999C22.8843 31.9999 28.7489 27.6578 31.0096 21.5651L16.0048 20.1738L1 21.5651Z" fill="#FFDA44"/>
<path d="M16.0048 0C9.12537 0 3.26069 4.342 1 10.4348L16.0048 11.8261L31.0096 10.4347C28.7489 4.342 22.8843 0 16.0048 0Z" fill="black"/>
<path d="M0.995188 10.4346C0.352063 12.1679 0 14.0426 0 15.9998C0 17.9569 0.352063 19.8316 0.995188 21.5649H31.0049C31.648 19.8316 32 17.9569 32 15.9998C32 14.0426 31.648 12.1679 31.0048 10.4346H0.995188Z" fill="#D80027"/>
</g>
<defs>
<clipPath id="clip0_9_3471">
<rect fill="white"/>
</clipPath>
</defs>
</svg>
